<template>
  <div class="contacts-card desktop-shadow-card desktop-white-bg rounded">
    <div class="card-header">
      <h4 class="card-header-title">
        <icon type="users" class="mr-2" /> Contacts
      </h4>
      <button
        @click="addContact()"
        class="btn btn-sm btn-success"
        v-if="!loading && userHasControl"
      >
        <i class="fas fa-plus"></i> Add Contact
      </button>
    </div>
    <alert
      v-if="!loading && contacts.results.length == 0"
      class="m-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
      >No Contacts</alert
    >
    <alert
      v-if="loading"
      type="loader"
      color="light"
      class="m-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
    />
    <table
      class="table table-striped mb-0"
      v-if="!loading && contacts.results.length > 0"
    >
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Primary Contact</th>
          <th v-if="userHasControl"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="contact in contacts.results"
          :key="contact.id"
          class="mobile-tablet-shadow-card rounded"
        >
          <td>
            <b class="mobile-tablet-only mr-2">Name:</b>{{ contact.user.last }},
            {{ contact.user.first }}
          </td>
          <td>
            <span class="text-muted small">
              <b class="mobile-tablet-only mr-2">Email:</b>
              <i class="fas fa-at mr-1"></i>
              {{ contact.user.email }}
            </span>
          </td>
          <td class="text-muted small">
            <span v-if="contact.user.phone">
              <b class="mobile-tablet-only mr-2">Phone:</b>
              <i class="fas fa-phone mr-1"></i>
              {{ contact.user.phone }}
            </span>
            <span v-else>N/A</span>
          </td>
          <td>
            <b class="mobile-tablet-only mr-2">Primary Contact:</b>
            <badge
              type="pill"
              class="ml-2 p-2"
              v-if="
                !userHasControl ||
                (loggedInUser.isVendor && loggedInUser.id == contact.user.id)
              "
              :color="contact.is_primary_contact ? 'success' : 'danger'"
            >
              <span
                v-html="
                  contact.is_primary_contact
                    ? `<i class='fas fa-check fa-fw'></i> Primary`
                    : `<i class='fas fa-times fa-fw'></i> Not Primary`
                "
              ></span>
            </badge>
            <button
              v-if="
                userHasControl &&
                (loggedInUser.isAdmin || loggedInUser.id != contact.user.id)
              "
              title="Change Primary"
              @click="toggleContactStatus(contact)"
              :disabled="contact.updating"
              class="btn btn-sm"
              :class="
                contact.is_primary_contact ? 'btn-success' : 'btn-warning'
              "
            >
              <span v-if="!contact.updating">
                <i
                  class="fas"
                  :class="contact.is_primary_contact ? 'fa-check' : 'fa-times'"
                  title="Change Primary"
                ></i>
                <span class="pl-2">{{
                  contact.is_primary_contact ? "Primary" : "Not Primary"
                }}</span>
              </span>
              <span
                class="spinner-border spinner-border-sm"
                v-if="contact.updating"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </td>

          <td class="text-right actions-td" v-if="userHasControl">
            <!-- v-if="!contact.primary" Need to check this for what-->
            <button
              class="btn btn-sm btn-outline-danger"
              @click="deleteContact(contact)"
              v-if="loggedInUser.isAdmin || loggedInUser.id != contact.user.id"
              :disabled="contact.deleting"
            >
              <i
                class="fas fa-trash fa-fw"
                v-if="!contact.deleting"
                title="delete"
              ></i>
              <i
                class="fas fa-spin fa-circle-notch fa-fw"
                v-if="contact.deleting"
              ></i>
              <span class="mobile-tablet-only pl-2">Delete</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <create-contact
      :vendor="vendor.id"
      :contacts="(contacts || {}).results"
      :reset="resetCount"
      v-if="modal.showing && vendor"
    />
  </div>
</template>
<script>
import CreateContact from "./Create";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Auth from "../../../auth";

export default {
  name: "Contacts",
  data() {
    return {
      resetCount: 0,
    };
  },
  components: {
    CreateContact,
  },
  computed: {
    ...mapState(["contacts", "vendors", "modal"]),
    loggedInUser: function () {
      return Auth.user.get();
    },
    vendor: function () {
      return this.vendors.single;
    },
    loading: function () {
      return this.contacts.loading;
    },
    userHasControl: function () {
      if (!this.vendor) {
        return false;
      }
      if (
        this.loggedInUser.isAdmin ||
        ((this.vendor.admins || []).length &&
          this.vendor.admins.includes(this.loggedInUser.id))
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (!this.vendors.single) {
      this.$store.dispatch("vendors/get", { id: this.$route.params.id });
    }
    this.get(this.$route.params.id);
  },
  methods: {
    get: function (id) {
      this.$store.dispatch("contacts/get", id);
    },
    addContact: function () {
      this.resetCount++;
      this.$store.dispatch("showModal", "create-contact");
    },
    deleteContact: function (contact) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            contact.deleting = true;
            this.$store.dispatch("contacts/delete", contact);
          }
        });
    },
    toggleContactStatus: function (contact) {
      let vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You are going to change the primary status for this user",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            contact.updating = true;
            vm.$forceUpdate();
            return this.$store
              .dispatch("contacts/updatePrimary", contact)
              .then((success) => {
                contact.updating = false;
                if (success) {
                  contact.is_primary_contact = !contact.is_primary_contact;
                }
                vm.$forceUpdate();
              });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 1024px) {
  .contacts-card {
    .card-header {
      padding: 0 !important;
    }
    table {
      display: flex;
    }
    thead {
      display: none;
    }
    tbody {
      width: 100%;
    }
    tr {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      padding: 8px;
      box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
      td {
        padding: 0 4px;
        text-align: left !important;
        border: 0 !important;
        b {
          display: inline-block;
          padding: 4px 0;
        }
        .text-muted,
        &.text-muted {
          color: #152e4d !important;
        }

        &.actions-td {
          text-align: center !important;
          margin-bottom: 8px;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #ccc !important;
        }
      }
    }
  }
}
</style>
